<template>
  <div class="upload-shp" v-show="showAddLocalVectorData">
    <div class="title">
      加载本地矢量文件 <span class="fa fa-close" @click="closePanle()"></span>
    </div>
    <el-upload
      class="upload-demo"
      ref="upload"
      action="/"
      multiple
      :on-change="onchange"
      :file-list="fileList"
      :on-remove="handleRemove"
      :auto-upload="false"
    >
      <el-button size="small" type="primary">选择矢量文件</el-button>
      <div slot="tip" class="el-upload__tip">
        请选择*.shp,*.json.*geojson文件,可选择多个
      </div>
    </el-upload>
    <div style="text-align: right; margin-top: 30px">
      <el-button
        style="margin-left: 0px"
        size="small"
        type="success"
        @click="getVectorFileList"
        >解析矢量文件</el-button
      >

      <el-button
        style="margin-left: 10px"
        size="small"
        type="success"
        @click="clearLayer()"
        >清除矢量文件</el-button
      >
    </div>
  </div>
</template>
<script>
import GeoJSON from "ol/format/GeoJSON";
var shapefile = require("shapefile");
export default {
  name: "shp",
  data() {
    return { fileList: [], map: null, layerList: [] };
  },
  watch: {},
  computed: {
    showAddLocalVectorData() {
      return this.$store.state.showAddLocalVectorData;
    },
  },
  components: {},
  methods: {
    closePanle() {
      this.$store.commit(
        "setShowAddLocalVectorData",
        !this.showAddLocalVectorData
      );
    },
    clearLayer() {
      this.layerList.forEach((layer) => {
        this.map.removeLayer(layer);
      });
    },
    handleRemove() {},
    decodeData() {},
    readShpData(shpfile) {
      return new Promise((resolve) => {
        var reader = new FileReader();
        reader.readAsArrayBuffer(shpfile);
        reader.onloadend = function (evt) {
          let shparray = evt.target.result;
          resolve(shparray);
        };
      });
    },
    readDbfData(dbffile) {
      return new Promise((resolve) => {
        var reader = new FileReader();
        reader.readAsArrayBuffer(dbffile);
        reader.onloadend = function (evt) {
          let shparray = evt.target.result;
          resolve(shparray);
        };
      });
    },
    readGeoJsonFileData(jsonfile) {
      return new Promise((resolve) => {
        var reader = new FileReader();
        reader.readAsText(jsonfile);
        reader.onloadend = function (evt) {
          let jsonStr = evt.target.result;
          let featureCollection = JSON.parse(jsonStr);
          resolve(featureCollection.features);
        };
      });
    },
    shpfile2GeoJson(shparray, dbfarray) {
      return new Promise((resolve) => {
        let features = [];
        shapefile
          .open(shparray, dbfarray, { encoding: "utf-8" })
          .then((source) =>
            source.read().then(function log(result) {
              if (result.done) {
                resolve(features);
                return;
              }
              features.push(result.value);
              return source.read().then(log);
            })
          )
          .catch((error) => {
            resolve([]);
            console.error(error.stack);
          });
      });
    },
    decodeFiles(finalFileArr) {
      return new Promise((resolve) => {
        finalFileArr.forEach(async (item, index) => {
          if (item.shpFile) {
            // 解析shp 文件
            let shparray = await this.readShpData(item.shpFile);
            let dbfarray = item.dbfFile
              ? await this.readShpData(item.dbfFile)
              : null;
            let features = await this.shpfile2GeoJson(shparray, dbfarray);
            item.features = features;
          }
          if (item.jsonFile) {
            // 解析geojson文件
            let features = await this.readGeoJsonFileData(item.jsonFile);
            item.features = features;
          }
          if (index == finalFileArr.length - 1) {
            resolve(true);
          }
        });
      });
    },
    onchange(file1, list) {
      let fileList = this.$refs.upload.uploadFiles;
      fileList.forEach((file, index) => {
        if (file.name.slice(-3) != "shp" && !/json/gim.test(file.name)) {
          //  if (file.name.slice(-3) != "shp" && file.name.slice(-3) != "dbf") {
          fileList.splice(index, 1);
        }
      });
    },
    async getVectorFileList() {
      let map = {};
      let fileList = this.$refs.upload.uploadFiles;
      fileList.forEach((file) => {
        if (file.name.slice(-3) == "shp") {
          //  if (file.name.slice(-3) == "shp" || file.name.slice(-3) == "dbf") {
          let fileName = file.name.slice(0, -4);
          if (fileName in map) {
            map[fileName]++;
          } else {
            map[fileName] = 1;
          }
        }
      });
      let finalFileArr = [];
      for (let key in map) {
        let obj = {
          layer_type: "geoJsonUpload",
        };
        fileList.forEach((file) => {
          if (file.name == key + ".shp") {
            obj.shpFile = file.raw;
          }
          if (file.name == key + ".dbf") {
            obj.dbfFile = file.raw;
          }
        });
        finalFileArr.push(obj);
      }
      fileList.forEach((file) => {
        let obj = {
          layer_type: "geoJsonUpload",
        };
        if (/json/gim.test(file.name)) {
          obj.jsonFile = file.raw;

          finalFileArr.push(obj);
        }
      });

      let decodeComplite = await this.decodeFiles(finalFileArr);

      if (decodeComplite) {
        this.layerList.forEach((layer) => {
          this.map.removeLayer(layer);
        });
        finalFileArr.forEach((layerInfo) => {
          let layer = this.xxMap.createLayer(layerInfo);
          this.layerList.push(layer);
          this.map.addLayer(layer);
        });
      }
    },
  },
  mounted() {
    this.xxMap.mapEventEmiter.$on("map-ready", (map) => {
      this.map = map;
    });
  },
};
</script>
 
<style scoped lang="less" >
.upload-shp {
  position: absolute;
  padding: 10px;
  top: 36px;
  right: 0px;
  background: #fff;
  width: 300px;
  z-index: 999;
  /deep/ input[type="file"] {
    display: none !important;
  }
  .title {
    height: 35px;
    font-size: 15px;
    .fa-close {
      float: right;
      font-size: large;
      color: #9f9c9c;
      margin-right: 10px;
    }
    .fa-close:hover {
      cursor: pointer;
      color: #706e6e;
    }
  }
}
</style>

 
